import { LinkButton, Theme, useDeviceType } from '@cian/ui-kit';
import * as styles from './styles.css';
import { clsx } from 'clsx';
import { TBanner } from 'shared/types/guide';

interface IBlueBannerProps {
  mainBanner: TBanner;
  secondBanner?: TBanner;
}

export const BlueBanner: React.FC<IBlueBannerProps> = ({
  mainBanner: { title, linkBtn, imageClass },
  secondBanner,
}) => {
  const device = useDeviceType();

  return (
    <div className={clsx(styles['container'], styles[device], secondBanner && styles['little'])}>
      <div className={styles['main-banner']}>
        <div className={styles['text-block']}>
          <div className={styles['title']}>{title}</div>
          <div className={styles['btn']}>
            <Theme theme="colored">
              <LinkButton fullWidth size={device === 'desktop' ? 'L' : 'M'} href={linkBtn.url} target="_blank">
                {linkBtn.text}
              </LinkButton>
            </Theme>
          </div>
        </div>
        <div className={clsx(styles['image'], styles[imageClass])} />
      </div>
      {secondBanner && (
        <div className={clsx(styles['second-banner'], styles['main-banner'])}>
          <div className={styles['text-block']}>
            <div className={styles['title']}>{secondBanner.title}</div>
            <div className={styles['btn']}>
              <Theme theme="colored">
                <LinkButton
                  fullWidth
                  size={device === 'desktop' ? 'L' : 'M'}
                  href={secondBanner.linkBtn.url}
                  target="_blank"
                >
                  {secondBanner.linkBtn.text}
                </LinkButton>
              </Theme>
            </div>
          </div>
          <div className={clsx(styles['image'], styles[secondBanner.imageClass])} />
        </div>
      )}
    </div>
  );
};
